/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DocumentsListPaginationQueryVariables = {
    count?: number | null;
    cursor?: string | null;
    tenantId: string;
};
export type DocumentsListPaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"DocumentsList_documents">;
};
export type DocumentsListPaginationQuery = {
    readonly response: DocumentsListPaginationQueryResponse;
    readonly variables: DocumentsListPaginationQueryVariables;
};



/*
query DocumentsListPaginationQuery(
  $count: Int = 9999
  $cursor: String
  $tenantId: ID!
) {
  ...DocumentsList_documents_Nd6Pz
}

fragment DocumentsList_documents_Nd6Pz on RootQueryType {
  documents: nodes(tenantId: $tenantId, types: ["ai.workflows.documents.document"], after: $cursor, first: $count) {
    edges {
      cursor
      node {
        __typename
        id
        ... on HasFiles {
          __isHasFiles: __typename
          files {
            edges {
              cursor
            }
          }
        }
        ... on Document {
          color
          hasUpdates
          insertedAt
          props
          title
          template {
            id
            title
          }
          ...Status_status
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Status_status on HasStatus {
  __isHasStatus: __typename
  status {
    name
    textColor
    color
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": 9999,
            "kind": "LocalArgument",
            "name": "count"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        } as any
    ], v1 = {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any,
        (v1 /*: any*/),
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "ai.workflows.documents.document"
            ]
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DocumentsListPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        },
                        (v1 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "DocumentsList_documents"
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DocumentsListPaginationQuery",
            "selections": [
                {
                    "alias": "documents",
                    "args": (v2 /*: any*/),
                    "concreteType": "NodeConnection",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "NodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FileConnection",
                                                    "kind": "LinkedField",
                                                    "name": "files",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FileEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "HasFiles",
                                            "abstractKey": "__isHasFiles"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasUpdates",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "insertedAt",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "props",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DocumentTemplate",
                                                    "kind": "LinkedField",
                                                    "name": "template",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Status",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "name",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "textColor",
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "HasStatus",
                                                    "abstractKey": "__isHasStatus"
                                                }
                                            ],
                                            "type": "Document",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "documents",
                    "args": (v2 /*: any*/),
                    "filters": [
                        "tenantId",
                        "types"
                    ],
                    "handle": "connection",
                    "key": "DocumentsList_documents",
                    "kind": "LinkedHandle",
                    "name": "nodes"
                }
            ]
        },
        "params": {
            "cacheID": "f9c57ce5f75630dcfc3dba99a7ff99fd",
            "id": null,
            "metadata": {},
            "name": "DocumentsListPaginationQuery",
            "operationKind": "query",
            "text": "query DocumentsListPaginationQuery(\n  $count: Int = 9999\n  $cursor: String\n  $tenantId: ID!\n) {\n  ...DocumentsList_documents_Nd6Pz\n}\n\nfragment DocumentsList_documents_Nd6Pz on RootQueryType {\n  documents: nodes(tenantId: $tenantId, types: [\"ai.workflows.documents.document\"], after: $cursor, first: $count) {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n        ... on HasFiles {\n          __isHasFiles: __typename\n          files {\n            edges {\n              cursor\n            }\n          }\n        }\n        ... on Document {\n          color\n          hasUpdates\n          insertedAt\n          props\n          title\n          template {\n            id\n            title\n          }\n          ...Status_status\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Status_status on HasStatus {\n  __isHasStatus: __typename\n  status {\n    name\n    textColor\n    color\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '33fc93d8e4e56101ea4a4d67744ba6eb';
export default node;
